import { colors } from '@constants/colors';
import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    badge: (isHidden: boolean) => ({
      '& .MuiBadge-badge': {
        backgroundColor: colors.red_second,
        display: isHidden ? 'none' : 'flex',
        right: 0,
        top: 0,
        padding: 0,
        pointerEvents: 'auto',
        minWidth: 'fit-content',
        height: 'fit-content',

        [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
          right: 2,
          top: 2,
        },
      },

      '& .MuiTypography-root': {
        borderRadius: '50%',
        display: 'flex',
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '14px',
        minWidth: '16px',
        height: '16px',
        width: '16px',
        alignItems: 'center',
        justifyContent: 'center',

        [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
          fontSize: 10,
          lineHeight: '10px',
          minWidth: '12px',
          height: '12px',
          width: '12px',
        },
      },
    }),
  };
};
